import axios from 'axios';

let prefix = "/quotation"

const QuotationApi = {

	getQuotationList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getQuotationById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createQuotation(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateQuotation(id, payload){
		return axios.post( prefix + "/update/" + id, payload)
	},
	updateQuotationStatus(id, payload){
		return axios.post( prefix + "/update-status/" + id, payload)
	},
	deleteQuotation(id){
		return axios.delete( prefix + "/delete/" + id)
	},

}

export default QuotationApi;
